module.exports = __webpack_public_path__ + "static/media/dima.3fe473d3.svg";